import * as React from 'react';
import { Link } from 'react-router-dom';

import { addModifiers } from '../../shared/helpers';
import analytics from '../../shared/services/analytics/analytics';

import { MenuListProps, MenuProps } from './types';
import './Menu.scss';
import { MenuFooter } from './MenuFooter';
import { Icon, Popup } from 'semantic-ui-react';
import { getLocalStorageItem, setLocalStorageItem } from '../../shared/helpers/local-storage';

const getOptionsProps = (props: MenuProps) => ({
  flashMessages: props.flashMessages,
  flashContext: props.flashContext,
  flashHandler: props.flashHandler,
  type: props.type,
  hasFlashMessages: props.hasFlashMessages,
  clearFlashMessage: props.clearFlashMessage,
  currentLevel: props.currentLevel,
  bottom: props.bottom,
  top: props.top,
  score: props.score,
  remaining: props.remaining,
  topMessage: props.topMessage,
  bottomMessage: props.bottomMessage,
  startDate: props.startDate,
  handleOpenGuidelines: props.handleOpenGuidelines,
  dataCompetitionsLevels: props.dataCompetitionsLevels,
  isAddToList: props.isAddToList,
});

const alphasSubPath: any = {
  unsubmitted: 'unsubmitted',
  submitted: 'submitted',
};
const SUBMISSION_SEEN_KEY = 'isSubmissionTipSeen';
const MenuListDefault = (props: MenuListProps) => (
  <ul className="intro-step-alphas-1 menu-top__list">
    {Object.keys(props.tabs).map((item: any, index: number) => {
      const handler = () => {
        // MenuListDefault is shared across pages (events, alphas, etc.). Only the
        // alphas page is in scope for BRAINTECH-5372 GA tracking; guard accordingly.
        if (props.menuType === 'alphas') {
          analytics.trackCustomEvent('alphas_click_tab', { event_label: item });
        }
        if (props.handleChangeTab) {
          props.handleChangeTab(item);
        }
      };

      const hideSubmissionsTip = () => {
        props.userId && setLocalStorageItem(props.userId, SUBMISSION_SEEN_KEY, 'true');
      };

      const isSubmissionSeen = !props.userId || getLocalStorageItem(props.userId, SUBMISSION_SEEN_KEY) === 'true';
      const isSubmissions = item === 'submissions';
      const isSubmissionsTooltipShown = isSubmissions && !isSubmissionSeen;
      const icon = isSubmissions ? <Icon name="cloud upload" className="menu-top__item-btn-icon" size="large" /> : <></>;

      return (
        <li
          key={`${item}-${index}`}
          className={`${props.menuType} ${addModifiers('menu-top__item', isSubmissions ? ['with-icon'] : [])}`}
          onClick={handler}
        >
          {props.menuType === 'alphas' ? (
            <Link
              to={`/${props.menuType}/${alphasSubPath[item]}`}
              className={addModifiers('menu-top__item-btn', item === props.type ? ['active', 'link'] : ['link'])}
            >
              {props.tabs[item]}
            </Link>
          ) : (
            <div>
              <Popup
                content="Click here for submission template and instructions"
                defaultOpen={isSubmissionsTooltipShown}
                position={'top center'}
                closeOnTriggerClick={true}
                closeOnTriggerBlur={true}
                onClose={hideSubmissionsTip}
                disabled={!isSubmissions}
                trigger={
                  <button className={addModifiers('menu-top__item-btn', item === props.type ? ['active'] : [])}>
                    {icon}
                    {props.tabs[item]}
                  </button>
                }
              />
            </div>
          )}
        </li>
      );
    })}
  </ul>
);

export const HOCMenu =
  (TitleComponent: any, OptionsComponent?: any, AlphaComponent?: any, FooterComponent: any = MenuFooter, MenuList: any = MenuListDefault) =>
  ({
    data = null,
    handleChange = null,
    handleMarkAsReadAll = null,
    handleBulk = null,
    isDefaultFavourite = true,
    isDefaultHidden = true,
    filterIsOpen = null,
    modifiers = [],
    handleShowBulkAction,
    activeBulkActions = false,
    ...props
  }: MenuProps) =>
    (
      <div className={addModifiers('menu', modifiers)}>
        <div className="menu-top menu-top--mobile-selected">
          <div className="menu-top__content">
            {TitleComponent && (
              <TitleComponent
                className="menu-top__title"
                title={props.title}
                helpText={props.helpText}
                options={props.titleOptions}
                profileLeaderboard={props.profileLeaderboard}
                type={props.type}
              />
            )}
            {props.type && (
              <MenuList
                tabs={props.tabs}
                handleChangeTab={props.handleChangeTab}
                type={props.type}
                menuType={props.menuType}
                options={props.listOptions}
                alphasChoicesOptions={props.alphasChoicesOptions}
                userId={props.userId}
              />
            )}
          </div>
          {AlphaComponent && props.type && <AlphaComponent type={props.type} handleChangeTab={props.handleChangeTab} />}
          {OptionsComponent !== null && (
            <div className="menu-top__action">
              <OptionsComponent
                data={data ? data : null}
                handleShowBulkAction={handleShowBulkAction}
                handleChange={handleChange}
                handleBulk={handleBulk}
                isDefaultFavourite={isDefaultFavourite}
                isDefaultHidden={isDefaultHidden}
                handleMarkAsReadAll={handleMarkAsReadAll}
                activeBulkActions={activeBulkActions}
                {...getOptionsProps(props)}
              />
            </div>
          )}
        </div>
        {FooterComponent && <FooterComponent filterIsOpen={filterIsOpen} {...props} />}
      </div>
    );
